@import ../../styles/helpers

.modal
    display: flex
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100%
    padding: 48px
    background: rgba($neutrals1,.9)
    opacity: 0
    animation: showModal .4s forwards
    overflow: auto
    z-index: 999
    +m
        padding: 32px 16px
    +dark
        background: rgba($neutrals2,.9)

@keyframes showModal
  0%
    opacity: 0
  100%
    opacity: 1

.outer
    max-width: 800px
    border-radius: $border_radius_small
    background-color: white
    position: relative
    position: relative
    overflow: hidden
    margin: auto
    z-index: 2
    +dark
        background: white
        box-shadow: inset 0 0 0 1px $neutrals3
.modal_content
    padding: $internal_margin $internal_margin

.modal_header
    width: 100%
    height: 50px
    position: relative
    display: flex
    justify-content: flex-end
    align-items: center
    background-color: $secondary
    padding: 0px $context_margin
    .close
        width: 40px
        height: 40px
        border-radius: 50%
        background: none
        border: none
        font-size: 0
        transition: transform 0.2s
        position: absolute
        padding: 5px
        svg
            fill: $light
            transition: transform .2s
            width: $small_icon_size
            height: $small_icon_size
        img
            height: 100%
        &:hover
            svg
                transform: rotate(90deg)

.title
    text-align: center
    font-size: 26px
    font-weight: 500 !important
    width: 100%
    text-transform: uppercase